import { UserRole } from "utils/checkRoleType"

export enum AccountSettingsTabId {
  PROFILE = "profile",
  ADDITIONAL_INFORMATION = "additional-information",
  PARTNERS = "partners",
  BILLING = "billing",
  PASSWORD = "password",
  INTEGRATIONS = "integrations",
  THEMES = "themes",
  NOTIFICATION_SETTINGS = "notification-settings",
}

export type AccountSettingsTab = {
  id: AccountSettingsTabId | "theme"
  label: string
  path: string
}

export const enterpriseAccountSettingsTabs: AccountSettingsTab[] = [
  { id: AccountSettingsTabId.PROFILE, label: "Profile", path: "/account/profile" },
  {
    id: AccountSettingsTabId.ADDITIONAL_INFORMATION,
    label: "Additional Information",
    path: "/account/additional-information",
  },
  { id: AccountSettingsTabId.PASSWORD, label: "Password", path: "/account/password" },
  { id: "theme", label: "Themes", path: "/account/theme" },
]

export const contractorAccountSettingsTabs: AccountSettingsTab[] = [
  { id: AccountSettingsTabId.PROFILE, label: "Profile", path: "/account/profile" },
  {
    id: AccountSettingsTabId.ADDITIONAL_INFORMATION,
    label: "Additional Information",
    path: "/account/additional-information",
  },
  { id: AccountSettingsTabId.PARTNERS, label: "Partners", path: "/account/partners" },
  { id: AccountSettingsTabId.BILLING, label: "Billing", path: "/account/billing" },
  { id: AccountSettingsTabId.PASSWORD, label: "Password", path: "/account/password" },
  { id: AccountSettingsTabId.INTEGRATIONS, label: "Integrations", path: "/account/integrations" },
  { id: AccountSettingsTabId.THEMES, label: "Themes", path: "/account/themes" },
  {
    id: AccountSettingsTabId.NOTIFICATION_SETTINGS,
    label: "Notification Settings",
    path: "/account/notification-settings",
  },
]

export const getAccountSettingsTabs = (userRole?: number) => {
  if ([UserRole.EnterpriseManager].includes(userRole as UserRole)) {
    return enterpriseAccountSettingsTabs
  }

  if (
    [
      UserRole.ContractorManager,
      UserRole.ContractorAdmin,
      UserRole.ContractorEngineer,
      UserRole.ContractorTechnician,
    ].includes(userRole as UserRole)
  ) {
    return contractorAccountSettingsTabs
  }

  return []
}

export const getDefaultAccountSettingsPath = (userRole?: number) =>
  getAccountSettingsTabs(userRole)[0]?.path || "/account"
